import {
  AnimationClassNames,
  Announced,
  MessageBar,
  MessageBarType,
} from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { useTranslation } from 'react-i18next';
import { PickerErrorBarAnnouncement } from './PickerErrorBarAnnouncement';

export interface IPickerErrorBar {
  /** Pop up message bar if the duration between start and end date is more than one year. */
  isMoreThanOneYear: boolean | undefined;
  /** Pop up message bar if the start date is before the end date. */
  isEndBeforeStart: boolean | undefined;
  /** Pop up message bar if any of the selected dates are in the future. */
  isAnyDateAfterToday: boolean | undefined;
}

/** UX for all the message bars that pop up when some error happens*/
export const PickerErrorBar = ({
  isMoreThanOneYear,
  isEndBeforeStart,
  isAnyDateAfterToday,
}: IPickerErrorBar) => {
  const [t] = useTranslation(['search', 'translation']);
  const announcedId = useId('searchbox-announced');
  return (
    <div>
      <PickerErrorBarAnnouncement
        {...{ isMoreThanOneYear, isEndBeforeStart, isAnyDateAfterToday }}
      />
      {isMoreThanOneYear && (
        <MessageBar
          role='status'
          id={`${announcedId}--date-is-not-between-one-year`}
          className={AnimationClassNames.slideDownIn10}
          messageBarType={MessageBarType.blocked}
          aria-hidden={true}
        >
          {t(
            'errorDateNotBetweenOneYear',
            'Duration between start and end date should be within a year.'
          )}
        </MessageBar>
      )}
      {isEndBeforeStart && (
        <MessageBar
          role='status'
          id={`${announcedId}--date-order`}
          className={AnimationClassNames.slideDownIn10}
          messageBarType={MessageBarType.blocked}
          aria-hidden={true}
        >
          {t('errorDatesBackwards', 'Start date is before end date')}
        </MessageBar>
      )}
      {isAnyDateAfterToday && (
        <MessageBar
          role='status'
          id={`${announcedId}--date-in-future`}
          messageBarType={MessageBarType.info}
          aria-hidden={true}
        >
          {t('errorFutureDate', 'You selected a date that is in the future')}
        </MessageBar>
      )}
    </div>
  );
};
